/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AdditionalWorkCreateRequest
 */
export interface AdditionalWorkCreateRequest {
  /**
   *
   * @type {number}
   * @memberof AdditionalWorkCreateRequest
   */
  additionalWorkId: number
}

/**
 * Check if a given object implements the AdditionalWorkCreateRequest interface.
 */
export function instanceOfAdditionalWorkCreateRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'additionalWorkId' in value

  return isInstance
}

export function AdditionalWorkCreateRequestFromJSON(json: any): AdditionalWorkCreateRequest {
  return AdditionalWorkCreateRequestFromJSONTyped(json, false)
}

export function AdditionalWorkCreateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdditionalWorkCreateRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    additionalWorkId: json['additionalWorkId'],
  }
}

export function AdditionalWorkCreateRequestToJSON(
  value?: AdditionalWorkCreateRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    additionalWorkId: value.additionalWorkId,
  }
}
